import { cloneDeep } from 'lodash';
import { DesignData } from 'src/store/design/types';
import adjustMugBlankArea from './adjustMugBlankArea';
import removeBlankArea from './removeBlankArea';

const adjustMugPrintAndBlankArea = (design: DesignData, printAreaValue: string) => {
  const result = cloneDeep(design);
  let mediaBoxDefinition = result.spreads[0].pages[0].groups.mediabox?.find((mediaBox) => mediaBox.name === 'Media Box');

  if (!mediaBoxDefinition) {
    mediaBoxDefinition = result.spreads[0].pages[0].groups.mediabox?.[0];
  }

  if (!mediaBoxDefinition) {
    return result;
  }

  switch (printAreaValue) {
    case 'simple-photo-left':
      mediaBoxDefinition.width /= 2;
      adjustMugBlankArea(result, mediaBoxDefinition, false);
      break;
    case 'simple-photo':
      mediaBoxDefinition.width /= 2;
      mediaBoxDefinition.x += mediaBoxDefinition.width;
      adjustMugBlankArea(result, mediaBoxDefinition, true);
      break;
    default:
      removeBlankArea(result);
  }

  return result;
};

export default adjustMugPrintAndBlankArea;
